import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Layout, Button, Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { Utils } from '../../../common/services/Utils';
import { TrainingProjectsStore } from '../../stores';
import { TrainingProjectsList, CreateEditTrainingProjectModal, ImportTrainingProjectModal } from '..';
import LayoutHeader from '../../../../components/LayoutHeader';

type Props = {
    store: TrainingProjectsStore;
};

const TrainingProjectsPage: React.FC<Props> = ({ store }) => {
    const handleFileUpload = React.useCallback(
        async (file: File) => {
            await store.importTrainingProject(file);
            return false;
        },
        [store]
    );

    return (
        <Layout>
            <LayoutHeader
                title="Training Projects"
                subtitle={Utils.getSubtitle(store.project)}
                buttons={[
                    <Upload
                        key="import-training-project"
                        accept=".json"
                        showUploadList={false}
                        beforeUpload={handleFileUpload}
                        className="headerButton"
                    >
                        <span data-id="button-Import" key="import-button-container">
                            <i className="alpha-icon xs arrow-down" style={{ verticalAlign: 'middle' }} />
                            <span className={'template-import-label'} style={{ marginLeft: 11 }}>
                                Import
                            </span>
                        </span>
                    </Upload>,
                    <Button
                        key="create-training-project"
                        size="large"
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => store.setCreateEditDialogVisible(true)}
                    >
                        Create training project
                    </Button>
                ]}
            />
            <CreateEditTrainingProjectModal store={store} />
            <ImportTrainingProjectModal store={store} />
            <Layout.Content>
                <TrainingProjectsList store={store} />
            </Layout.Content>
        </Layout>
    );
};

export default observer(TrainingProjectsPage);
